import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './SkillSelector.css';

const DEFAULT_API_URL =
  typeof window !== 'undefined' && window.location.hostname.includes('localhost')
    ? 'http://localhost:5000/api'
    : 'https://vet-career-translator.onrender.com/api';

const API_URL = (process.env.REACT_APP_API_URL || DEFAULT_API_URL).trim();

function SkillSelector({ selectedSkills = [], onRoleToggle }) {
  const [skills, setSkills] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [expandedSkill, setExpandedSkill] = useState(null);

  useEffect(() => {
    fetchSkills();
  }, []);

  const fetchSkills = async () => {
    setLoading(true);
    setError('');

    try {
      const response = await axios.get(`${API_URL}/military-skills`);
      const sortedSkills = response.data.sort((a, b) => 
        a.military_term.localeCompare(b.military_term)
      );
      setSkills(sortedSkills);
    } catch (error) {
      console.error('Error fetching skills:', error);
      setError('Could not load roles. The backend may still be waking up.');
      setSkills([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="skill-selector-loading">Loading skills...</div>;
  }

  if (error) {
    return (
      <div className="skill-selector-error">
        <p>{error}</p>
        <button type="button" className="retry-btn" onClick={fetchSkills}>Retry Loading Roles</button>
      </div>
    );
  }

  if (skills.length === 0) {
    return (
      <div className="skill-selector-empty">
        <p>No roles available right now.</p>
        <button type="button" className="retry-btn" onClick={fetchSkills}>Retry</button>
      </div>
    );
  }

  return (
    <div className="skill-selector">
      <div className="skills-grid">
        {skills.map(skill => (
          <div key={skill.id}>
            <div
              className={`skill-card ${selectedSkills.includes(skill.id) ? 'selected' : ''}`}
            >
              <div className="skill-content">
                <input
                  type="checkbox"
                  id={`skill-${skill.id}`}
                  checked={selectedSkills.includes(skill.id)}
                  onChange={() => onRoleToggle(skill.id)}
                  className="skill-checkbox"
                />
                <label htmlFor={`skill-${skill.id}`} className="skill-label">
                  <div className="skill-title">{skill.military_term}</div>
                  <div className="skill-translations">
                    {skill.civilian_translations.join(' • ')}
                  </div>
                </label>
              </div>
              <button
                className="expand-btn"
                onClick={() => setExpandedSkill(expandedSkill === skill.id ? null : skill.id)}
                title="View more details"
              >
                {expandedSkill === skill.id ? '↑' : '↓'}
              </button>
            </div>
            {expandedSkill === skill.id && (
              <div className="skill-details">
                <p>
                  <strong>Civilian Equivalents:</strong>
                </p>
                <ul>
                  {skill.civilian_translations.map((trans, idx) => (
                    <li key={idx}>{trans}</li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default SkillSelector;
